import React, { useState, useRef, useEffect } from "react";
import ProductImage from "../../assets/Cart/OrthoLatexMattress.png";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TimeIcon from "../../assets/icons/Time Icon.png";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import CheckIcon from "@mui/icons-material/Check";
import ShippingForm from "./ShippingForm";
import CouponsOffcanvas from "./CouponsOffcanvas";
import OptionsOffcanvas from "./OptionsOffcanvas";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import loadinganimation from "../../assets/animations/Stopwatch.lottie";
import SelectAddressCanvas from "./SelectAddressCanvas";
export default function CheckoutOrders() {
  const [quantity, setQuantity] = useState(1);
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const [loginSuccess, setLoginSuccess] = useState(false);
  const isDisabled = !loginSuccess;
  const [otpError, setOtpError] = useState("");
  const [showCoupons, setShowCoupons] = useState(false);
  const [showOptionsCanvas, setShowOptionsCanvas] = useState(false);
  const [showShippingForm, setShowShippingForm] = useState(false);
  const [selected, setSelected] = useState({
    size: "Single",
    inch: "72x72 Inch",
    cm: "(182x182 cm)",
    thicknessValue: "6",
    thicknessUnit: "Inch",
  });
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [couponInput, setCouponInput] = useState("");
  const [couponError, setCouponError] = useState("");
  const [pincode, setPincode] = useState("");
  const [loading, setLoading] = useState(false);
  const [showAddressCanvas, setShowAddressCanvas] = useState(false);

  const [isExistingUser, setIsExistingUser] = useState(() => {
    const storedValue = localStorage.getItem("existingUser");
    return storedValue ? storedValue === "true" : false;
  });
  const phoneRef = useRef(null);
  const couponRef = useRef(null);

  const validCoupons = [
    { code: "MOONPAY", discount: 6174 },
    { code: "MOONUPI", discount: 6174 },
    { code: "MOONCARD", discount: 6174 },
  ];

  // const options = [
  //   {
  //     size: "Single",
  //     inch: "72x72 Inch",
  //     cm: "(182x182 cm)",
  //     thicknessValue: "6",
  //     thicknessUnit: "Inch",
  //   },
  //   {
  //     size: "Queen",
  //     inch: "72x72 Inch",
  //     cm: "(182x182 cm)",
  //     thicknessValue: "6",
  //     thicknessUnit: "Inch",
  //   },
  //   {
  //     size: "King",
  //     inch: "72x72 Inch",
  //     cm: "(182x182 cm)",
  //     thicknessValue: "6",
  //     thicknessUnit: "Inch",
  //   },
  // ];

  const unitPrice = 44480;
  const unitBaseDiscount = 4480;
  const cartTotal = quantity * unitPrice;
  const baseDiscount = quantity * unitBaseDiscount;
  const couponDiscount = appliedCoupon ? appliedCoupon.discount : 0;
  const totalAmount = cartTotal - baseDiscount - couponDiscount;
  const [selectedAddress, setSelectedAddress] = useState(null);
  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  React.useEffect(() => {
    if (!showOtp) {
      phoneRef.current?.focus();
    }
  }, [showOtp]);

  React.useEffect(() => {
    if (!appliedCoupon) {
      couponRef.current?.focus();
    }
  }, [appliedCoupon]);

  const handleOtpChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    setOtpError(""); // ✅ clear red state

    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`)?.focus();
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();

      const newOtp = [...otp];

      if (newOtp[index]) {
        // If current box has value → just clear it
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        // If empty → move to previous and clear it
        newOtp[index - 1] = "";
        setOtp(newOtp);
        document.getElementById(`otp-${index - 1}`)?.focus();
      }
    }
  };

  React.useEffect(() => {
    if (!showOtp) return;

    setCanResend(false);
    setTimer(30);

    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev === 1) {
          clearInterval(interval);
          setCanResend(true); // ✅ enable resend
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    setTimeout(() => {
      document.getElementById("otp-0")?.focus();
    }, 0);

    return () => clearInterval(interval);
  }, [showOtp]);

  const handleResendOtp = () => {
    if (!canResend) return;

    console.log("Resend OTP to:", phone);

    // ✅ CLEAR OTP INPUTS
    setOtp(["", "", "", "", "", ""]);

    // focus first input after clearing
    setTimeout(() => {
      document.getElementById("otp-0")?.focus();
    }, 0);

    // restart timer
    setTimer(30);
    setCanResend(false);
  };

  const handleApplyCoupon = (e) => {
    if (e) e.preventDefault();
    if (couponInput) {
      const upperCode = couponInput.toUpperCase();
      const coupon = validCoupons.find((c) => c.code === upperCode);
      if (coupon) {
        setAppliedCoupon(coupon);
        setCouponInput("");
        setCouponError("");
      } else {
        setCouponError("Coupon does not exist");
      }
    }
  };

  const handleRemoveCoupon = (e) => {
    if (e) e.preventDefault();
    setAppliedCoupon(null);
  };

  const handleGetOtp = (e) => {
    if (e) e.preventDefault();
    const isValidPhone = /^[6-9][0-9]{9}$/.test(phone);
    if (!isValidPhone) {
      setPhoneError(true);
      return;
    }
    setShowOtp(true);
    setTimer(26);
  };

  const handleVerifyOtp = (e) => {
    if (e) e.preventDefault();
    const enteredOtp = otp.join("");
    if (enteredOtp.length !== 6) {
      setOtpError("Enter complete OTP");
      return;
    }
    setOtpError("");
    setLoginSuccess(true);
  };

  const handleCheckPincode = (e) => {
    if (e) e.preventDefault();
    console.log("Checking pincode:", pincode);
    // Implement pincode check logic here
  };

  const loadingPincode = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#f5f6f1]  md:py-[120px] py-24 relative ">
      <div className="sm:max-w-full md:max-w-[80%] xl:max-w-[80rem] 3xl:max-w-[90rem] mx-auto space-y-8">
        {/* ================= ROW 1 ================= */}
        <div className="grid grid-cols-1 xl:grid-cols-[1.8fr_1.2fr] gap-8 xl:auto-rows-fr">
          {/* PRODUCT */}
          <div className="bg-[#ffffff] rounded-xl p-6 flex flex-col  lg:flex-row items-center md:items-start gap-6 xl:h-full mx-4 md:mx-0">
            <img src={ProductImage} alt="Mattress" className="rounded-xl" />

            <div className="flex-1">
              <h3 className="font-semibold xxs:text-[18px] xs:text-[20px] sm:text-[22px] md:text-[26px] font-lexend leading-[26px] text-center md:text-left md:te">
                Ortho Latex Mattress
              </h3>
              {/* OPTIONS & QUANTITY */}
              <div className="mt-5 w-full max-w-full 3xl:max-w-[80%] relative font-lexend">
                <div
                  onClick={() => setShowOptionsCanvas(true)}
                  className="w-full border border-[#b1b1b1] rounded-lg px-4 py-3 flex items-center justify-between cursor-pointer bg-white"
                >
                  <p className="xxs:text-[9px] xs:text-[12px] sm:text-[14px] md:text-[18px]">
                    <span className="font-semibold">
                      {selected.size}, {selected.inch}
                    </span>{" "}
                    <span className="text-[#3f3f3f]">{selected.cm}</span>,{" "}
                    <span className="font-semibold">
                      {selected.thicknessValue} {selected.thicknessUnit}
                    </span>
                  </p>
                  <ExpandMoreIcon className="text-[#afafaf]" />
                </div>
              </div>

              <div className="mt-7 inline-flex font-lexend items-center border border-[#b1b1b1] rounded-lg overflow-hidden select-none">
                <button
                  onClick={() => setQuantity((q) => Math.max(1, q - 1))}
                  disabled={quantity === 1}
                  className={`px-4 py-1 text-lg font-semibold bg-[#f2f1f6]
                    ${quantity === 1 ? "text-gray-400 cursor-not-allowed" : "text-[#333333]"}`}
                >
                  −
                </button>

                <div className="px-6 py-1 text-[16px] font-semibold text-[#333333] bg-white">
                  {quantity}
                </div>

                <button
                  onClick={() => setQuantity((q) => q + 1)}
                  className="px-4 py-1 text-lg font-semibold text-[#333333] bg-[#f2f1f6]"
                >
                  +
                </button>
              </div>

              <div className="mt-6 flex flex-wrap items-end gap-3">
                <p className="text-[24px] md:text-[36px] font-normal font-calsans text-[#333333]">
                  ₹44,480
                </p>
                <p className="line-through font-lexend font-light text-[#a7a7a5] xxs:text-[9px] xs:text-[12px] sm:text-[14px] md:text-[18px]">
                  MRP ₹59,300
                </p>
                <p className="text-[#73a763] font-semibold font-lexend xxs:text-[9px] xs:text-[12px] sm:text-[14px] md:text-[18px]">
                  40% off
                </p>
                <p className="font-lexend font-light text-[#a7a7a5] xxs:text-[9px] xs:text-[12px] sm:text-[14px] md:text-[18px]">
                  (Incl of all Taxes)
                </p>
              </div>
            </div>
          </div>

          {/* DELIVERY */}
          <div className="bg-[#ffffff] rounded-xl p-6 xl:h-full">
            <h3 className="font-semibold font-lexend text-[#333333] text-[20px] mb-3">
              Delivery & Store Details
            </h3>
            <form onSubmit={handleCheckPincode}>
              <div className="flex sm:flex-row xs:flex-col gap-3 mt-5">
                <input
                  type="text"
                  inputMode="numeric"
                  maxLength={6}
                  placeholder="Enter Pincode"
                  value={pincode}
                  className="border font-lexend text-[18px] rounded-lg px-4 py-2 flex-1
             text-[#333333] placeholder:text-[#a7a7a5]
             focus:outline-none focus:border-[#2f5d3a] focus:ring-1 focus:ring-[#2f5d3a]"
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    if (value.length <= 6) {
                      setPincode(value);
                    }
                  }}
                />
                <button
                  type="submit"
                  onClick={loadingPincode}
                  className="bg-[#2f5d3a] font-semibold text-[#f4e391] font-lexend text-[18px] 3xl:text-[22px] px-6 rounded-lg"
                >
                  Check
                </button>
              </div>
            </form>

            <div className="mt-6 flex items-center justify-center gap-8 bg-[#deecdd] px-8 rounded-lg">
              {" "}
              {/* {loading ? (
                
              ) : (
                <> */}
              <div>
                {loading ? (
                  <div className="overflow-hidden">
                    <DotLottieReact
                      src={loadinganimation}
                      autoplay
                      loop
                      className="w-15 h-15"
                    />
                  </div>
                ) : (
                  <img src={TimeIcon} alt="Delivery" />
                )}
              </div>
              <div className="font-lexend py-4 ">
                <p className="text-[#2a552f] xxs:text-[9px] xs:text-[12px] sm:text-[14px] md:text-[18px] font-light">
                  Your kind of rest, <br />
                  <span className="text-[20px] font-semibold">
                    delivered in 24 hours.
                  </span>
                </p>
                <p className="text-[#809882] text-[12px] md:text-[14px] mt-1">
                  Enjoy quick & hassle-free delivery to your doorstep.
                </p>
              </div>
              {/* </>
              )} */}
            </div>
          </div>
        </div>

        {/* ================= ROW 2 ================= */}
        <div className="grid grid-cols-1 xl:grid-cols-[1.8fr_1.2fr] gap-8 xl:auto-rows-fr">
          {/* SIGN IN */}
          <div className="bg-[#ffffff] rounded-xl p-6 xl:h-full">
            <h3 className="font-semibold font-lexend text-[20px] text-[#333333] mb-2">
              Sign in or Sign up
            </h3>

            {!showOtp && (
              <>
                <p className="font-lexend font-light xxs:text-[9px] xs:text-[12px] sm:text-[14px] md:text-[18px] mb-5">
                  Enter your phone number and we will send you a 6 digit OTP.
                </p>

                <form onSubmit={handleGetOtp}>
                  <div className="flex sm:flex-row xs:flex-col gap-5 md:w-[70%] w-full ">
                    <input
                      ref={phoneRef}
                      type="text"
                      placeholder="Phone *"
                      value={phone}
                      inputMode="numeric"
                      maxLength={10}
                      className={`border font-lexend xxs:text-[9px] xs:text-[12px] sm:text-[14px] md:text-[18px] rounded-lg px-4 py-2 flex-1 font-light
            text-[#333333] placeholder:text-[#a7a7a5]
            focus:outline-none focus:ring-1
            ${
              phoneError
                ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                : "focus:border-[#2f5d3a] focus:ring-[#2f5d3a]"
            }`}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        if (value.length <= 10) {
                          setPhone(value);
                          setPhoneError(false);
                        }
                      }}
                    />

                    <button
                      type="submit"
                      className="bg-[#2f5d3a] font-semibold text-[#f4e391] font-lexend text-[18px] 3xl:text-[22px] px-2 md:px-6 rounded-lg"
                    >
                      Get OTP
                    </button>
                  </div>
                </form>

                {phoneError && (
                  <p className="text-red-500 text-sm mt-1 font-lexend">
                    Enter a valid 10-digit mobile number
                  </p>
                )}
              </>
            )}

            {loginSuccess ? (
              /* ✅ SUCCESS SCREEN */
              <div className="flex items-center justify-center gap-4 mt-4">
                <div className="w-12 h-12 rounded-full bg-[#609b4d] flex items-center justify-center">
                  <CheckIcon
                    sx={{ fontSize: 28, fontWeight: "black" }}
                    className="text-white"
                  />
                </div>

                <div className="font-lexend">
                  <p className="font-semibold text-[20px] text-[#333333]">
                    Login successful.
                  </p>
                  <p className="xxs:text-[9px] xs:text-[12px] sm:text-[14px] md:text-[18px] font-light text-[#a7a7a5]">
                    One step closer to mindful rest.
                  </p>
                </div>
              </div>
            ) : (
              showOtp && (
                /* 🔐 OTP UI (UNCHANGED) */
                <>
                  <p className="font-lexend font-light xxs:text-[9px] xs:text-[12px] sm:text-[14px] md:text-[18px] mb-4">
                    Please enter the 6 digit OTP here
                  </p>

                  <form onSubmit={handleVerifyOtp}>
                    <div className="flex sm:flex-row xs:flex-col gap-2 mb-1">
                      {otp.map((digit, index) => (
                        <input
                          key={index}
                          id={`otp-${index}`}
                          type="text"
                          maxLength={1}
                          value={digit}
                          inputMode="numeric"
                          className={`w-7 h-7 md:w-12 md:h-12 text-center border rounded-md xxs:text-[9px] xs:text-[12px] sm:text-[14px] md:text-[18px] font-lexend
focus:outline-none focus:ring-1
${
  otpError && !digit
    ? "border-red-500 focus:border-red-500 focus:ring-red-500"
    : "border-gray-300 focus:border-[#2f5d3a] focus:ring-[#2f5d3a]"
}`}
                          onChange={(e) =>
                            handleOtpChange(e.target.value, index)
                          }
                          onKeyDown={(e) => handleOtpKeyDown(e, index)}
                        />
                      ))}

                      <button
                        type="submit"
                        className="bg-[#2f5d3a] font-semibold text-[#f4e391] font-lexend text-[18px] md:text-[22px] px-6 rounded-lg py-1 ml-4"
                      >
                        Verify
                      </button>
                    </div>
                  </form>

                  {otpError && (
                    <p className="text-red-500 text-sm font-lexend">
                      {otpError}
                    </p>
                  )}

                  <p className="font-lexend font-light xxs:text-[9px] xs:text-[12px] sm:text-[14px] md:text-[18px] text-[#333333]">
                    {canResend ? (
                      <span
                        onClick={handleResendOtp}
                        className="cursor-pointer text-[#2f5d3a] font-semibold"
                      >
                        Resend OTP?
                      </span>
                    ) : (
                      <>
                        Resend OTP in {timer} seconds{" "}
                        <span className="text-[#b3d2b1] font-medium ml-1">
                          Resend OTP?
                        </span>
                      </>
                    )}
                  </p>
                </>
              )
            )}
          </div>

          {/* COUPONS */}
          <div className="bg-[#ffffff] rounded-xl p-6 xl:h-full flex flex-col">
            <h3 className="font-semibold font-lexend text-[20px] text-[#333333] mb-3">
              Coupons & Offers
            </h3>

            <form
              onSubmit={appliedCoupon ? handleRemoveCoupon : handleApplyCoupon}
            >
              <div className="flex sm:flex-row xs:flex-col gap-3">
                <input
                  ref={couponRef}
                  type="text"
                  placeholder="Enter Coupon Code"
                  value={appliedCoupon ? appliedCoupon.code : couponInput}
                  onChange={(e) =>
                    !appliedCoupon &&
                    setCouponInput(e.target.value.toUpperCase())
                  }
                  readOnly={!!appliedCoupon}
                  className={`border font-lexend xxs:text-[9px] xs:text-[12px] sm:text-[14px] md:text-[18px] rounded-lg px-4 py-2 flex-1 font-light
             text-[#333333] placeholder:text-[#a7a7a5]
             focus:outline-none focus:border-[#2f5d3a] focus:ring-1 focus:ring-[#2f5d3a]
             ${appliedCoupon ? "bg-gray-100 cursor-not-allowed" : ""}`}
                />
                {appliedCoupon ? (
                  <button
                    type="submit"
                    className="bg-red-600 text-white font-calsans text-[18px] 3xl:text-[22px] px-3 md:px-6 rounded-lg"
                  >
                    Remove
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="bg-[#2f5d3a] text-[#f4e391] font-lexend text-[18px] 3xl:text-[22px] font-semibold px-3 md:px-6 rounded-lg"
                  >
                    Apply
                  </button>
                )}
              </div>
            </form>

            {couponError && (
              <p className="text-red-500 text-sm mt-1 font-lexend">
                {couponError}
              </p>
            )}

            <p
              onClick={() => setShowCoupons(true)}
              className="font-lexend text-[18px] text-[#333333] mt-6 cursor-pointer self-end flex items-center gap-1"
            >
              View All Coupons
              <KeyboardArrowRightIcon className="text-[#2f5d3a]" />
            </p>
          </div>
        </div>

        {/* ================= ROW 3 ================= */}
        <div className="grid grid-cols-1 xl:grid-cols-[1.8fr_1.2fr] gap-8 items-start">
          {/* SHIPPING */}
          {loginSuccess && !isExistingUser && <ShippingForm />}

          {loginSuccess && isExistingUser && (
            <div className="bg-[#ffffff] rounded-xl p-6  space-y-6">
              {/* BUTTONS */}
              <div className="flex justify-end">
                <div className="flex gap-4 w-full md:w-auto">
                  <button
                    onClick={() => {
                      setShowAddressCanvas(true);
                      setShowShippingForm(false); // ✅ hide form when selecting address
                    }}
                    className="bg-[#2f5d3a] text-[#f4e391] font-lexend text-[18px] px-6 rounded-lg py-2"
                  >
                    Select address
                  </button>
                  <button
                    onClick={() => {
                      setSelectedAddress(null); // ✅ CLEAR selected address
                      setShowShippingForm(true);
                    }}
                    className="border border-[#2f5d3a] text-[#2f5d3a] font-lexend text-[18px] px-6 rounded-lg py-2"
                  >
                    Add address
                  </button>
                </div>
              </div>

              {/* SHIPPING FORM INSIDE SAME BOX */}
              {showShippingForm && (
                <div className="border-t">
                  <ShippingForm
                    key={selectedAddress ? "edit" : "new"}
                    selectedAddress={selectedAddress}
                    isReadOnly={!!selectedAddress} // ✅ ADD THIS
                  />
                </div>
              )}
            </div>
          )}

          {!loginSuccess && (
            <div className="bg-[#ffffff] rounded-xl p-6 flex justify-between items-center">
              <h3 className="font-semibold font-lexend text-[#818181] text-[20px]">
                Shipping
              </h3>
              <ExpandMoreIcon sx={{ color: "#718172", fontSize: 32 }} />
            </div>
          )}
          {/* PRICE DETAILS */}
          <div className="bg-[#ffffff] rounded-xl p-6">
            <h3 className="font-semibold font-lexend text-[20px] text-[#333333] mb-3">
              Price Details{" "}
              <span className="text-[#a7a7a5] font-light">
                ({quantity} Item{quantity > 1 ? "s" : ""})
              </span>
            </h3>

            <div className="font-lexend xxs:text-[9px] xs:text-[12px] sm:text-[14px] md:text-[18px] font-light text-[#333333] divide-y divide-[#deecdd] h-">
              <div className="flex justify-between py-4">
                <span>Cart Total</span>
                <span>₹{cartTotal.toLocaleString("en-IN")}</span>
              </div>

              <div className="flex justify-between py-4">
                <span>Discount</span>
                <span>-₹{baseDiscount.toLocaleString("en-IN")}</span>
              </div>

              {appliedCoupon && (
                <div className="flex justify-between py-4">
                  <span>Coupon Discount ({appliedCoupon.code})</span>
                  <span>-₹{couponDiscount.toLocaleString("en-IN")}</span>
                </div>
              )}

              <div className="flex justify-between py-4">
                <span>Delivery Charges</span>
                <span>
                  Free <del>₹800</del>
                </span>
              </div>
            </div>

            <div className="flex justify-between  border-t border-[#deecdd] py-4 ">
              <div>
                <p className="font-semibold font-lexend text-[20px] xl:text-[26px] ">
                  Total Amount
                </p>
                <p className="text-[16px] xl:text-[18px] font-lexend font-light text-[#a2a19f]">
                  (inclusive of all taxes)
                </p>
              </div>
              <p className="text-[20px] xl:text-[26px] font-lexend font-semibold">
                ₹{totalAmount.toLocaleString("en-IN")}
              </p>
            </div>
            {/* <div className="flex flex-row gap-8 items-center my-4">
              <button className="bg-[#2f5d3a] font-normal text-[#f4e391] font-lexend text-[18px] 3xl:text-[24px] px-6 rounded-lg py-2 w-full">
                Select address
              </button>
              <button className="border border-[#2f5d3a] font-normal text-[#2f5d3a] font-lexend text-[18px] 3xl:text-[24px] px-6 rounded-lg w-full  py-2">
                Add address
              </button>
            </div> */}
            <button
              disabled={isDisabled}
              className={`mt-3 w-full py-3 rounded-lg font-semibold font-lexend text-[20px] xl:text-[25px]
    ${
      isDisabled
        ? "bg-[#deecdd] text-[#fff] cursor-not-allowed"
        : "bg-[#2f5d3a] text-[#f4e391]"
    }`}
            >
              Check out
            </button>
          </div>
        </div>
      </div>
      {showAddressCanvas && (
        <SelectAddressCanvas
          onClose={() => setShowAddressCanvas(false)}
          onSelectAddress={(address) => {
            setSelectedAddress(address); // ✅ set selected
            setShowShippingForm(true); // ✅ OPEN form after selection
          }}
        />
      )}
      {showOptionsCanvas && (
        <OptionsOffcanvas
          isOpen={showOptionsCanvas} // ✅ ADD THIS
          onClose={() => setShowOptionsCanvas(false)}
          selected={selected}
          setSelected={setSelected}
          quantity={quantity}
          setQuantity={setQuantity}
        />
      )}

      {showCoupons && (
        <CouponsOffcanvas
          onClose={() => setShowCoupons(false)}
          onApply={(coupon) => setAppliedCoupon(coupon)}
        />
      )}
    </div>
  );
}
